// Copyright (C) 2017-2023 Smart code 203358507

const Board = require('./Board');
const Discover = require('./Discover');
const Library = require('./Library');
const MetaDetails = require('./MetaDetails');
const NotFound = require('./NotFound');
const Search = require('./Search');
const { default: Settings } = require('./Settings');
const Player = require('./Player');
const Intro = require('./Intro');
const CarolineAuth = require('./CarolineAuth').default;
const CarolineAdmin = require('./CarolineAdmin').default;
const CarolineDeviceAuthorization = require('./CarolineDeviceAuthorization/CarolineDeviceAuthorization').default;

module.exports = {
    Board,
    Discover,
    Library,
    MetaDetails,
    NotFound,
    Search,
    Settings,
    Player,
    Intro,
    CarolineAuth,
    CarolineAdmin,
    CarolineDeviceAuthorization
};
